import { JobsService } from "./../../main/accountant/jobs-and-tasks/jobs.service";
import { HotToastService } from "@ngneat/hot-toast";
import { QuickbooksIntegrationService } from "./../../quickbooks-integration.service";
import { WorkspacesService } from "./../../main/accountant/workspaces.service";
import { ChatService } from "./../../chat.service";
import {
  Component,
  OnInit,
  ViewChildren,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  signal,
  computed,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { LoginService } from "../../../login/login.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ConversationsService } from "../../conversations/conversations.service";
import { DashboardService } from "../../dashboard.service";
import { ClientService } from "../../main/client/client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { GeneralUtil } from "../../../utils/general";

import { Firestore, addDoc, collection } from "@angular/fire/firestore";

import * as _ from "underscore";

// Modals
import { ChatSettingsModalComponent } from "../../conversations/modals/chat-settings-modal.component";
import { CreateConversationModalComponent } from "../../conversations/modals/create-conversation-modal.component";
import { CommentsModalComponent } from "../../conversations/modals/comments-modal.component";
import { NewTrackedItemModalComponent } from "../../conversations/modals/new-tracked-item-modal.component";

import { Conversation } from "../../conversations/panels/conversation.model";
import { Subscription } from "rxjs";
import { DashboardStore } from "../../dashboard.store";
import { GenericDrawerService } from "../../drawer/global-drawer.service";
import { QboClientTasksComponent } from "../qbo-client-tasks/qbo-client-tasks.component";
import { RealTimeService } from "../../main/common/notifications/real-time.service";
import { first } from "rxjs";
import { XeroClientTasksComponent } from "../xero-client-tasks/xero-client-tasks.component";
import { TrackedItemBubbleComponent } from "../tracked-item-bubble/tracked-item-bubble.component";
import { NgIf, NgClass, NgFor } from "@angular/common";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { MomentModule } from "ngx-moment";
import { ConfirmationModalComponent } from "../../main/accountant/modals/confirmation-modal.component";
declare var jQuery: any;

@Component({
  selector: "app-tracked-items-panel",
  templateUrl: "./tracked-items-panel.component.html",
  styleUrls: ["../../main/accountant/workspaces.component.scss"],
  imports: [
    NgIf,
    NgClass,
    NgFor,
    TrackedItemBubbleComponent,
    TooltipModule,
    MomentModule,
  ],
})
export class TrackedItemsPanelComponent implements OnInit {
  bsModalRef: BsModalRef;
  @ViewChildren("bubble") bubbles;
  clients = [];
  generalUtil = new GeneralUtil();
  user: any;
  data: any = this.localStorage.get("data");
  accounting_company: any;
  showChat = true;
  showTrackedItems = false;
  showFiles = false;
  conversationsListOpen = true;
  conversations_loaded = false;
  showOpenTrackedItems = true;
  is_archived = false;
  is_tab_active = true;

  active_conversation: any = {
    members: [],
    messages: [],
    tracked_items: [],
    company: { name: "" },
    files: { images: [], documents: [] },
  };
  dispatchSub: Subscription;
  _conversation: Conversation;
  _company: any;
  accounts = [];
  classes = [];
  salesTaxes = [];

  qboTrackedItems = {
    expense_items: {},
    deposit_items: {},
    receipt_requests: {},
  };

  qboTrackedItemsCounts = computed(() =>
    this.quickbooksIntegrationService.qboTrackedItemsCounts(),
  );

  isQboConnected = false;

  hasSelectableClass = false;
  hasSelectableSalesTax = false;

  activeTab = "open";
  page = 1;

  loading = false;

  subscriptions: Subscription[] = [];

  realtimeUpdateSubscriptions = [];

  isXeroConnected = false;
  xeroTrackedItems = [];
  xeroTrackedItemsCounts = {
    unanswered_count: 0,
    to_review_count: 0,
  };

  lastReminderSentDate = signal(null);

  @Input()
  set conversation(value: Conversation) {
    if (value?.uuid !== undefined) {
      this.page = 1;
      this.isQboConnected = false;
      this.isXeroConnected = false;

      this._conversation = value;

      this._conversation.tracked_items = [];
      // this.loadTrackedItems(this.activeTab);

      this.changeTab.emit("open");
      this.activeTab = "open";
      this.switchTabs(this.activeTab);

      this.conversationsService.getTrackedItemsTabCountSubject.next(
        this._conversation.uuid,
      );

      this.realTimeService.setConversationUpdatesListener(
        this._conversation.uuid,
      );

      this.realtimeUpdateUnsubscribe();

      this.realtimeUpdateSubscriptions.push(
        this.realTimeService.conversationUpdates$.subscribe((message: any) => {
          const trackedUuid =
            message?.tracked_item?.uuid ?? message?.tracked_item_uuid;
          const isDelete = message?.action === "delete";

          const index = this._conversation.tracked_items.findIndex(
            (item) => item["uuid"] === trackedUuid,
          );

          if (index !== -1) {
            if (isDelete) {
              this._conversation.tracked_items.splice(index, 1);
            } else {
              this._conversation.tracked_items[index] = message.tracked_item;
            }

            this.loadXeroTrackedItems();
            this.conversationsService.getTrackedItemsTabCountSubject.next(
              this._conversation.uuid,
            );
          }
        }),
      );

      this.realtimeUpdateSubscriptions.push(
        this.realTimeService.newTrackedItem.subscribe(
          (trackedItemUuids: any) => {
            if (trackedItemUuids != null && Array.isArray(trackedItemUuids)) {
              //only checking for array while we don't update mobile
              trackedItemUuids.forEach((trackedItemUuid) => {
                this.conversationsService
                  .get_tracked_item(trackedItemUuid)
                  .then((res: any) => {
                    let found = false;
                    for (
                      let i = 0;
                      i < this._conversation.tracked_items.length;
                      i++
                    ) {
                      if (
                        this._conversation.tracked_items[i]["uuid"] === res.uuid
                      ) {
                        this._conversation.tracked_items[i] = res;
                        found = true;
                        break;
                      }
                    }

                    if (!found) {
                      this._conversation.tracked_items.push(res);
                    }
                  });
              });
            }

            this.conversationsService.getTrackedItemsTabCountSubject.next(
              this._conversation.uuid,
            );
          },
        ),
      );

      this.realtimeUpdateSubscriptions.push(
        this.conversationsService.newPlaceholderTrackedItems.subscribe(
          (trackedItems: any) => {
            this._conversation.tracked_items =
              this._conversation.tracked_items.concat(trackedItems);
            this.cdr.detectChanges();
          },
        ),
      );
    }
  }

  @Input()
  set company(value: any) {
    this._company = value;
    // Get realmId accounts on QBO
    if (this._company != null) {
      if (this._company.id != null) {
        this.quickbooksIntegrationService
          .getAccountsByCompanyId(this._company.id)
          .subscribe((res) => {
            this.accounts = res;
          });
        this.quickbooksIntegrationService
          .retrieveClasses(this._company.id)
          .then(
            (res) => {
              this.hasSelectableClass = res.enabled;
              this.classes = res.classes;
            },
            (err) => {
              if (err.status == 404) {
                this.hasSelectableClass = false;
              }
            },
          );
        this.quickbooksIntegrationService
          .retrieveSalesTaxes(this._company.id)
          .then(
            (res) => {
              this.hasSelectableSalesTax = res.enabled;
              this.salesTaxes = res.tax_codes;
              console.log("salesTaxes", this.salesTaxes);
              console.log("hasSelectableSalesTax", this.hasSelectableSalesTax);
            },
            (err) => {
              console.log(err);
              this.hasSelectableSalesTax = false;
            },
          );
      }

      // this.chatService.subscribeToUpdates([this._company]);
    }
  }

  public options: Object = {
    toolbarInline: true,
    toolbarVisibleWithoutSelection: true,
    charCounterCount: false,
    placeholderText: "Type the response text here",
    toolbarButtons: ["insertLink", "bold", "italic", "underline", "emoticons"],
    key: "uXD2lD6D6D5G4F4C3kD-17usE-11rivjbC5cstyD2I2D1A3C7E2D1C5G1C1==",
  };

  moment_calendar_format = {
    sameDay: "h:mm A",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    lastDay: "[Yesterday -] H:mm A",
    lastWeek: "[Last] dddd",
    sameElse: "h:mm A - MMM D",
  };

  trackedItemsSub: any = null;

  @Output() changeTab = new EventEmitter();

  constructor(
    private localStorage: LocalStorageService,
    private loginService: LoginService,
    private clientService: ClientService,
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    public dashboardStore: DashboardStore,
    private workspacesService: WorkspacesService,
    private modalService: BsModalService,
    private firestore: Firestore,
    private _sanitizer: DomSanitizer,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef,
    private toastr: HotToastService,
    private quickbooksIntegrationService: QuickbooksIntegrationService,
    public jobsService: JobsService,
    private genericDrawerService: GenericDrawerService,
    private realTimeService: RealTimeService,
  ) {
    // cdr.detach(); // deactivate change detection
    // setInterval(() => {
    //   this.cdr.detectChanges(); // manually trigger change detection
    // }, 250);

    this.getTrackedItemsTabCount = _.debounce(
      this.getTrackedItemsTabCount,
      3000,
    );

    this.loadQboTrackedItems = _.debounce(this.loadQboTrackedItems, 1000);
    this.loadXeroTrackedItems = _.debounce(this.loadXeroTrackedItems, 1000);
  }

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.accounting_company = this.localStorage.get("company");

    this.conversationsService.getTrackedItemsTabCountSubject
      .pipe(first())
      .subscribe((sub) => {
        if (this._conversation != null) {
          if (this._conversation.uuid == sub) {
            this.getTrackedItemsTabCount();
            this.loadQboTrackedItems();
            this.loadXeroTrackedItems();
          }
        }
      });

    this.getTrackedItemsTabCount();

    this.conversationsService.showTrackedItems.subscribe((sub: any) => {
      this.showOpenTrackedItems = false;
      // this.switchChatTabs("tracked-items");

      jQuery(".tracked-item").removeClass("flash");
      setTimeout(() => {
        let rendered_bubbles = this.bubbles.toArray();
        for (let b = 0; b < rendered_bubbles.length; b++) {
          if (rendered_bubbles[b].nativeElement.id == `bubble-${sub.message}`) {
            rendered_bubbles[b].nativeElement.classList.add("animated");
            rendered_bubbles[b].nativeElement.classList.add("delay-1");
            rendered_bubbles[b].nativeElement.classList.add("flash");
            rendered_bubbles[b].nativeElement.scrollIntoView();
          }
        }
      }, 100);
    });

    this.conversationsService.conversations_loaded.subscribe((sub: any) => {
      this.conversations_loaded = sub;
    });

    this.dashboardService.getOpenTrackedItemsCount
      .pipe(first())
      .subscribe((sub) => {
        this.loadQboTrackedItems();
        this.loadXeroTrackedItems();
      });

    jQuery("body").on("click", ".toggle-panel", function () {
      jQuery(this).closest(".ch-panel").toggleClass("panel-hidden");
    });
    this.getLastReminderSentDate();
  }

  ngOnDestroy() {
    this.realtimeUpdateUnsubscribe();
  }

  getTrackedItemsTabCount() {
    this.workspacesService
      .get_tracked_items_tab_count(this._conversation.id, "open")
      .subscribe((res: any) => {
        this._conversation["open_tasks_count"] = res.count;
        this._conversation["answered_tasks_count"] = res.answered_count;
      });
  }

  sanitize(image) {
    return this._sanitizer.bypassSecurityTrustUrl(`${image}`);
  }

  public openModal(modal, tracked_item = null): void {
    if (modal === "settings") {
      modal = ChatSettingsModalComponent;
    }
    if (modal === "create-conversation") {
      modal = CreateConversationModalComponent;
    }

    if (modal === "comments") {
      modal = CommentsModalComponent;
      this.bsModalRef = this.modalService.show(modal, {
        initialState: { tracked_item: tracked_item },
      });
      return;
    }

    if (modal === "new-tracked-items") {
      modal = NewTrackedItemModalComponent;
      this.bsModalRef = this.modalService.show(modal, {
        class: "modal-lg modal-client-tasks",
        ignoreBackdropClick: true,
        initialState: { conversation_id: this._conversation.id },
      });
      return;
    }

    this.bsModalRef = this.modalService.show(modal, {
      initialState: {
        clients: this.clients,
        accountants: this.accounting_company,
        conversation_id: this._conversation,
      },
    });
  }

  countTrackedMessages(tracked_items): number {
    return tracked_items.filter((t) => {
      return t.created_by !== null;
    }).length;
  }

  countTrackedRespondedMessages(tracked_items): number {
    return tracked_items.filter((t) => {
      return t.answered;
    }).length;
  }

  countAllButAccepted(tracked_items): number {
    return tracked_items.filter((t) => {
      return !t.satisfied;
    }).length;
  }

  countPendingReview(tracked_items): number {
    return tracked_items.filter((t) => {
      return t.answered && t.satisfied == null;
    }).length;
  }

  countOpenTrackedItems(tracked_items): number {
    return tracked_items.filter((t) => {
      return t.satisfied !== true;
    }).length;
  }

  closeConversationListByChildClick(): void {
    this.conversationsListOpen = false;
  }

  fileChange(event, tracked_item): void {
    let target = event.target || event.srcElement;

    tracked_item.file_to_upload = target.files;
  }

  answerTrackedItem(tracked_item, satisfied): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .answer_tracked_item(tracked_item.id, satisfied)
      .then(
        (res: any) => {
          const response = res;
          tracked_item = response.tracked_item;

          // this.conversationsService.getConnection().emit('tracked_item', {message: message, system_message: response.system_message});
          this.toastr.success(res.message);
          this.dashboardService.show_loading.next(false);
          if (satisfied && res.is_last_task) {
            this.jobsService.jobCompletedConfirmation(
              res.job_uuid,
              this.modalService,
              ConfirmationModalComponent,
              this.toastr,
            );
          }
        },
        (err) => {
          this.toastr.error(err.error.message);
          this.dashboardService.show_loading.next(false);
        },
      );
  }

  submitAnswer(tracked_item): void {
    let fileForm = new FormData();

    if (
      tracked_item.file_to_upload !== null &&
      tracked_item.file_to_upload !== undefined
    ) {
      const file: File = tracked_item.file_to_upload[0];
      fileForm.append("file", file, file.name);
      tracked_item.upload_loading = true;
    }

    fileForm.append(
      "qbo_account",
      JSON.stringify(tracked_item.selectedAccount),
    );
    fileForm.append("qbo_class", tracked_item.selectedClass);
    fileForm.append("tracked_item_id", tracked_item.id);
    fileForm.append("answer", tracked_item.answer);
    fileForm.append("answer_text", tracked_item.answer_text);
    fileForm.append("answer_done", tracked_item.answer_done);

    // this.dashboardService.show_loading.next(true);
    this.conversationsService
      .submit_answer(this._conversation.id, fileForm)
      .then(
        (res: any) => {
          tracked_item.file_to_upload = null;
          tracked_item.upload_loading = false;
        },
        (err) => {
          console.log(err);
          tracked_item.upload_loading = false;
        },
      );
  }

  logout(): void {
    this.loginService.logout();
  }

  selectAccount(event: any, tracked_item: any) {
    tracked_item.selectedAccount = event.item;
    tracked_item.selectedAcc = event.item.name;
  }

  send_comment(message, tracked_item_id, input): void {
    this.conversationsService
      .comment_tracked_item(tracked_item_id, message)
      .then((res: any) => {
        input.value = "";
        input.focus();
      });
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.is_tab_active = false;
    } else {
      this.is_tab_active = true;
    }
  }

  handleReminderSuccess(res: any) {
    this.lastReminderSentDate.set(res.data);
    this.toastr.success("Reminder sent successfully!");
  }
  handleError(err: any, message?: string) {
    let displayableMessage = err.message ? err.message : message;
    this.toastr.error(displayableMessage);
  }

  sendReminder(conversationUuid: string) {
    this.conversationsService.sendReminder(conversationUuid).then(
      (res) => this.handleReminderSuccess(res),
      (err) => this.handleError(err, "Error sending reminder."),
    );
  }

  send_reminder(conversation): void {
    var publishConfig = {
      channel: `conversation-${conversation.uuid}`,
      message: {
        message: "",
        tracked_item: null,
        system_message: true,
        file: null,
        date: this.chatService.getFirestoreServerDate(),
        reminder_creator: {
          full_name: this.localStorage.get("user")["full_name"],
          id: this.localStorage.get("user")["id"],
          email: this.localStorage.get("user")["email"],
        },
        sent_by: {
          full_name: this.localStorage.get("user")["full_name"],
          id: this.localStorage.get("user")["id"],
          email: this.localStorage.get("user")["email"],
        },
        reminder: true,
      },
    };

    addDoc(
      collection(this.firestore, `chats/${this._conversation.uuid}/messages`),
      publishConfig.message,
    )
      .then((res: any) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.success("Reminder sent successfully!");
      })
      .catch((err) => {
        console.log("Error sending reminder", err);
        this.toastr.error("Error sending reminder");
      });
  }

  trackById(index, tracked_item) {
    return tracked_item.id;
  }

  showFilename(event, tracked_item) {
    event.target.innerHTML = `<i class="feather download"></i> ${tracked_item.answer_filename}`;
  }

  showDefaultFilename(event) {
    event.target.innerHTML = `<i class="feather download"></i> Download file`;
  }

  shouldDisable(tracked_item) {
    return (
      (tracked_item.type == 2 &&
        (tracked_item.file_to_upload == undefined ||
          tracked_item.file_to_upload == null)) ||
      ((tracked_item.type == 1 || tracked_item.type == 4) &&
        (tracked_item.answer == null || tracked_item.answer == undefined)) ||
      (tracked_item.type == 3 &&
        (tracked_item.answer_text == null ||
          tracked_item.answer_text == undefined ||
          tracked_item.answer_text == "")) ||
      (tracked_item.type == 5 &&
        (tracked_item.answer_done == null ||
          tracked_item.answer_done == undefined ||
          tracked_item.answer_done == false)) ||
      (tracked_item.type == 6 &&
        (tracked_item.selectedAcc == null ||
          tracked_item.selectedAcc == undefined))
    );
  }

  switchTabs(tab) {
    if (this.trackedItemsSub != null) {
      this.trackedItemsSub.unsubscribe();
    }

    if (tab != this.activeTab) {
      this.loading = true;
      this._conversation.tracked_items = [];
      this.page = 1;
    }

    if (tab == "open") {
      this.activeTab = "open";
      this.showOpenTrackedItems = true;

      // this.changeTab.emit("open");
    }

    if (tab == "all") {
      this.activeTab = "all";
      this.showOpenTrackedItems = false;
      // this.changeTab.emit("all");
    }
    this.cdr.detectChanges();

    this.loadTrackedItems(this.activeTab);

    this.loadQboTrackedItems();
    this.loadXeroTrackedItems();

    this.cdr.detectChanges();
  }

  loadMore() {
    this.page = this.page + 1;
    this.loadTrackedItems(this.activeTab);
  }

  loadTrackedItems(tab) {
    // this.loadings["tracked_items"] = true;
    this.loading = true;
    return (this.trackedItemsSub = this.workspacesService
      .get_tracked_items_v2(this._conversation.id, tab, this.page)
      .pipe(first())
      .subscribe(
        (res: any) => {
          if (this._conversation.tracked_items.length == 1) {
            this._conversation.tracked_items = [];
          }

          this._conversation.tracked_items =
            this._conversation.tracked_items.concat(res);
          this.workspacesService.checkTrackedItemsCount.next(null);
          this.loading = false;
          // this.loadings["tracked_items"] = false;
          // this.cdr.detectChanges();
        },
        (err) => {
          console.log(err);
          // this.loadings["tracked_items"] = false;
        },
      ));
  }

  hasQboTrackedItems() {
    const qboCounts = this.quickbooksIntegrationService.qboTrackedItemsCounts();
    return qboCounts.unanswered_count + qboCounts.to_review_count > 0;
  }

  loadQboTrackedItems() {
    return this.workspacesService
      .get_qbo_tracked_items(this._conversation.id, this.activeTab)
      .then(
        (res: any) => {
          this.qboTrackedItems = {
            expense_items: res.expense_items,
            deposit_items: res.deposit_items,
            receipt_requests: res.receipt_requests,
          };

          this.isQboConnected = res.has_qbo_connection;

          this.quickbooksIntegrationService.qboTrackedItemsCounts.set(
            res.counts,
          );
          console.log(
            "qboTrackedItemsCounts",
            this.quickbooksIntegrationService.qboTrackedItemsCounts(),
          );
          this.cdr.detectChanges();
        },
        (err) => {
          console.log(err);
        },
      );
  }

  loadXeroTrackedItems() {
    return this.workspacesService
      .get_xero_tracked_items(this._conversation.id, this.activeTab)
      .then(
        (res: any) => {
          this.isXeroConnected = res.xero_integrated;

          this.xeroTrackedItemsCounts = res.counts;
          this.cdr.detectChanges();
        },
        (err) => {
          console.log(err);
        },
      );
  }

  openQBOPanel() {
    this.genericDrawerService.changeComponent(QboClientTasksComponent, {
      conversation: this._conversation,
      qboTrackedItems: this.qboTrackedItems,
      accounts: this.accounts,
      classes: this.classes,
      hasSelectableClass: this.hasSelectableClass,
      salesTaxes: this.salesTaxes,
      hasSelectableSalesTax: this.hasSelectableSalesTax,
      company: this._company,
    });
  }

  openXeroPanel() {
    this.genericDrawerService.changeComponent(XeroClientTasksComponent, {
      conversation: this._conversation,
      xeroTrackedItems: [],
      accounts: [],
      company: this._company,
    });
  }

  realtimeUpdateUnsubscribe() {
    this.realtimeUpdateSubscriptions.forEach((sub) => {
      sub.unsubscribe();
    });

    this.realtimeUpdateSubscriptions = [];
  }

  async getLastReminderSentDate() {
    const reminder =
      await this.conversationsService.getLastTrackedItemsReminder(
        this._conversation.uuid,
      );
    this.lastReminderSentDate.set(reminder.data);
  }
}
